/**
 * app/(marketing)/legal/index.tsx - getabeam.com Legal Center hub (web, public).
 *
 * Lists the published policies (Terms, Privacy, Refunds). Content + rendering live in
 * src/marketing/legal.ts and src/marketing/legalPage.tsx so this route stays structural.
 */
import { LegalCenter } from '../../../src/marketing/legalPage';

export default function LegalCenterScreen() {
  return <LegalCenter />;
}
